export default "/assets/images/workspace.png?b781c8238082adfe0f2b046e9a567916";